import { useCallback, useState } from 'react'

export type Photo = {
  id: number
  filename: string
  thumbnail_url: string
  url: string
}

export const useAISuggestion = () => {
  const [assetName, setAssetName] = useState<string | undefined>(undefined)
  const [photo, setPhoto] = useState<Photo | undefined>(undefined)

  const [responseData, setResponseData] = useState(undefined)

  const onSubmit = useCallback(
    (photo?: Photo) => {
      setPhoto(photo)

      // TODO: Call AI API to get suggestion for asset name or photo
    },
    [assetName]
  )

  return {
    photo,
    onSubmit,
    assetName,
    setAssetName,
    responseData,
    setResponseData,
  }
}
